const getNewAssetSrc = (imgName, imgSrc, { height, width }) => {
  const assetsDirSrc = imgSrc.slice(0, imgSrc.length - imgName.length);
  const extension = imgName.slice(imgName.lastIndexOf('.'));
  const newName = imgName.replace(extension, `-${width}x${height}`);

  return `${assetsDirSrc}${newName}${extension}`;
};

export default getNewAssetSrc;
